import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { CloudFileListingContext } from "../../CloudFileListingContext";
import { ApproveCloudFileNotificationsDialog } from "./ApproveCloudFileNotificationsDialog";
import { mapToApproveNotificationsItem } from "./ApproveNotificationsItem";

export const ApproveCloudFileNotificationsButton = (): JSX.Element => {
    const { selectedItems } = useContext(CloudFileListingContext);
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <CommandBarButton
                text="Approve notifications"
                icon="Ringer"
                disabled={!selectedItems.length}
                onClick={onOpen}
            />
            <ApproveCloudFileNotificationsDialog
                key={String(isOpen)}
                isOpen={isOpen}
                onClose={onClose}
                selectedItems={selectedItems.map(mapToApproveNotificationsItem)}
            />
        </AuthorizationWrapper>
    );
};
